/**
 * Solana money config for the web app. Parked behind VITE_NETWORK=solana so the
 * EVM path (contracts/chains.ts) stays the default until the program is live.
 */
export const SOLANA_NETWORK = (import.meta.env.VITE_NETWORK ?? "evm").toLowerCase() === "solana";

/** Mainnet public RPC by default; an Alchemy/Helius URL via VITE_SOLANA_RPC_URL in prod. */
export const SOLANA_RPC_URL = (import.meta.env.VITE_SOLANA_RPC_URL as string | undefined) ?? "https://api.mainnet-beta.solana.com";

/** base58 program id (the synced keypair-derived id). NOT lowercased. */
export const HUPPER_ESCROW_PROGRAM_ID =
  (import.meta.env.VITE_HUPPER_ESCROW_PROGRAM_ID as string | undefined) ?? "RAW7dgEuw7NUs8fXd1LgvNddGr1d85Yv8959ATVUwYw";

export const LAMPORTS_PER_SOL = 1_000_000_000;
export const SOL_DECIMALS = 9;

/** Lamports → SOL display string (trimmed). */
export function formatSol(lamports: bigint, dp = 4): string {
  const sol = Number(lamports) / LAMPORTS_PER_SOL;
  return sol.toFixed(dp).replace(/\.?0+$/, "");
}

/** SOL (number) → lamports (bigint), rounding to whole lamports. */
export function solToLamports(sol: number): bigint {
  return BigInt(Math.round(sol * LAMPORTS_PER_SOL));
}

/** Network fee reserve for the 1-signature withdraw tx. The embedded wallet is
 *  the fee payer, so its spendable balance is `walletBalance - this`. */
export const WITHDRAW_FEE_LAMPORTS = 5_000n;
